import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  z-index: 99;
`;
